import { ChangeDetectorRef, Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { GraphService } from 'src/app/services/graph.service';
declare const $:any;

@Component({
  selector: 'smart-graph',
  templateUrl: './graph.component.html',
  styleUrls: ['../graph-color.css','../../platform-color/platform-color.css']
})
export class GraphComponent implements OnInit {
  @Input() id: string;
  @Output() filter = new EventEmitter<any>();

  form: FormGroup;
  setting = {
    left: true,
    right: false,
    refresh: true
  };

  farmLeft = [];
  farmRight = [];
  plotLeft = [];
  plotRight = [];
  thingLeft = [];
  thingRight = [];
  senLeft = [];
  senRight = [];

  colorSetting = [
    "#7cb6ec",
    "#8085e9",
    "#434348",
    "#90ed7d"
  ];

  plotDashboardLeft = [];
  plotDashboardRight = [];

  sensorDataLeft = [];
  sensorDataRight = [];

  loading: boolean = true;
  loadingGraph: boolean = false;
  currentOrg: string;
  currentChildOrg: string;
  emptySensorModal: string = '#emptySensorModal';
  emptyPlotModal: string = '#emptyPlotModal';
  emptyThingModal: string ='#emptyThingModal';
  limitGraphModal: string = '#limitGraphModal';
  
  number_of_sensor: number = 0;
  interval = null;
  setting_graph = null;

  constructor(
    private toastr: ToastrService,
    private GraphService: GraphService,
    private spinner: NgxSpinnerService,
    private _formBuilder: FormBuilder,
    private cd: ChangeDetectorRef
  ) { }

  async ngOnInit() {
    this.spinner.show();
    this.currentOrg = sessionStorage.getItem('Org');
    this.currentChildOrg = sessionStorage.getItem('ChildOrg');

    const currentPackage = JSON.parse(sessionStorage.getItem('package'));

    if(currentPackage){
      this.GraphService.getPackage(currentPackage['package_id']).then(res=>{
        this.number_of_sensor = res.data.sensor_no;
      })
    }
    this.createForm();
    this.valueChange();
    this.getFarmselect();
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    this.clearinterval();
  }

  clearinterval(){
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  async setinterval(){
    this.clearinterval();

    let form = this.form.getRawValue();

    if(form.refresh_status && form.refresh_value){
      this.interval = setInterval(async () => {
        
        let sen_left = form.sen_left;
        if(sen_left){
          await this.getSenLeft(sen_left);
        }else{
          this.sensorDataLeft = [];
        }
        let sen_right = form.sen_right;
        if(sen_right){
          await this.getSenRight(sen_right);
        }else{
          this.sensorDataRight = [];
        }
        this.toastr.success(`${this.id} ข้อมูลเซนเซอร์มีการอัพเดต`, 'Refresh Data!', {
          timeOut: 4000,
        });

      }, form.refresh_value * 1000 * 60);
    }
  }

  createForm(){
    this.settingGraph();
    this.setting_graph = this.getSessionStorage();
    
    this.form = this._formBuilder.group({
      refresh_status: [this.setting_graph.refresh_status],
      refresh_value: [this.setting_graph.refresh_value || ""],
      receive_date: [`${moment(new Date()).subtract(30, 'days').format('DD MMM YYYY')} - ${moment(new Date()).format('DD MMM YYYY')}`],
      farm_left: [""],
      farm_right: [""],
      plot_left: [""],
      plot_right: [""],
      thing_left: [""],
      thing_right: [""],
      sen_left: [""],
      sen_right: [""]
    });
    this.setinterval();
  }

  settingGraph(){
    let graph_setting = JSON.parse(sessionStorage.getItem('graph_setting'));

    if(graph_setting == null) graph_setting = [];

    if(!graph_setting.find(graph=> graph.id == this.id)){
      let settings = {
        id: this.id,
        refresh_status: false,
        refresh_value: 5
      }
      graph_setting.push(settings);

      sessionStorage.setItem('graph_setting', JSON.stringify(graph_setting));
    }
  }

  getSessionStorage(){
    let graph_setting = JSON.parse(sessionStorage.getItem('graph_setting'));

    return graph_setting.find(graph=> graph.id == this.id);
  }

  setSessionStorage(){
    let graph_setting = JSON.parse(sessionStorage.getItem('graph_setting'));
    let value = this.form.getRawValue();
    graph_setting.map(setting=>{
      if(setting.id == this.id){
        setting.refresh_status = value.refresh_status;
        setting.refresh_value = parseInt(value.refresh_value);
        setting['farm_left'] =  value.farm_left;
        setting['plot_left'] =  value.plot_left;
        setting['thing_left'] =  value.thing_left;
        setting['sen_left'] =  value.sen_left;
        setting['farm_right'] =  value.farm_right;
        setting['plot_right'] =  value.plot_right;
        setting['thing_right'] =  value.thing_right;
        setting['sen_right'] =  value.sen_right;
      }
    })
    sessionStorage.setItem('graph_setting', JSON.stringify(graph_setting));
  }

  valueChange(){
    this.form.controls.receive_date.valueChanges.subscribe(
      async (value) => {
        if(value != this.form.value['receive_date']){
          let sen_left = this.form.getRawValue().sen_left;

          if(sen_left){
            await this.getSenLeft(sen_left);
          }else{
            this.sensorDataLeft = [];
          }
          let sen_right = this.form.getRawValue().sen_right;
          if(sen_right){
            await this.getSenRight(sen_right);
          }else{
            this.sensorDataRight = [];
          }
        }
      }
    );

    this.form.controls.refresh_status.valueChanges.subscribe(
      async (value) => {

        if(value != this.form.value['refresh_status']){
          this.setSessionStorage();
          this.setinterval();
        }
      }
    );

    this.form.controls.refresh_value.valueChanges.subscribe(
      async (value) => {

        if(value != this.form.value['refresh_value']){
          this.setSessionStorage();
          this.setinterval();
        }
      }
    );

    this.form.controls.farm_left.valueChanges.subscribe(async (value) => {

        if(value != this.form.value['farm_left']){
          this.form.get('plot_left').setValue("");
          this.form.get('thing_left').setValue("");
          this.form.get('sen_left').setValue("");
          
          await this.GraphService.getPlotDashboard(value[0].id)
          .then(success => {

            this.plotDashboardLeft = success.data.plot;

            this.plotLeft = this.plotDashboardLeft.map(plot=>{
              return {
                id: plot._id,
                label: plot.name,
                data: plot
              }
            });

            if(this.plotLeft.length > 0){
              if(this.setting_graph.plot_left && this.plotLeft.find(plot=> plot.id == this.setting_graph.plot_left[0].id)){
                this.form.get('plot_left').setValue(this.setting_graph.plot_left);
              }else{
                this.form.get('plot_left').setValue([this.plotLeft[0]]);
              }
              this.resetTemplate();
            }
          }).catch(err=>{

            this.plotLeft = [];
            this.thingLeft = [];
            this.sensorDataLeft = [];
            $(`${this.emptyPlotModal}`).modal('show');

            this.setSessionStorage();
            this.resetTemplate();
          });
        }
    });

    this.form.controls.plot_left.valueChanges.subscribe(async (value) => {

      if (value != this.form.value["plot_left"]) {
        this.form.get('thing_left').setValue("");
        this.form.get('sen_left').setValue("");
        this.thingLeft = [];


        if (value[0]) {
          let plotList = this.plotDashboardLeft
          .filter(plot=> plot._id == this.form.getRawValue().plot_left[0].id);

          await Promise.all(plotList
            .map(async plot=>{

              await Promise.all(plot.thing
                .map(async thing=>{

                  this.thingLeft.push(
                    {
                      id:  thing.thing_id,
                      label: thing.thing_name,
                      data: thing
                    }
                  )
              }));
  
              if(this.thingLeft.length > 0){
                if (this.setting_graph.thing_left && this.thingLeft.find(thing=> thing.id == this.setting_graph.thing_left[0].id)) {
                  this.form.get("thing_left").setValue(this.setting_graph.thing_left);
                } else {

                  this.form.get("thing_left").setValue([this.thingLeft[0]]);
                }
              }else{
                this.thingLeft = [];
                $(`${this.emptyThingModal}`).modal("show");
              }
              this.resetTemplate();
          }));
        }
      }
    });

    this.form.controls.thing_left.valueChanges.subscribe(async (value) => {

      if (value != this.form.value["thing_left"]) {
        this.form.get("sen_left").setValue("");
        this.senLeft = [];
        
        if (value[0]) {
          let plot =  this.plotDashboardLeft.find(plot=> plot._id == this.form.getRawValue().plot_left[0].id)
         
          if(plot){
            let thing = plot.thing.find(thing=> thing.thing_id == this.form.getRawValue().thing_left[0].id);

            if(thing){
    
              this.senLeft = thing.sensor.map(sen=>{
                return {
                  id: sen.sensor_id,
                  label: sen.sensor_name,
                  data: sen
                }
              });

              if(this.senLeft.length > 0){
                if (this.setting_graph.sen_left && this.senLeft.find(sen=> sen.id == this.setting_graph.sen_left[0].id)) {
                  this.form.get("sen_left").setValue(this.setting_graph.sen_left);
                } else {
                  this.form.get("sen_left").setValue([this.senLeft[0]]);
                }
              }else{
                this.senLeft = [];
                $(`${this.emptySensorModal}`).modal("show");
              }
            }else{
              this.senLeft = [];
              $(`${this.emptySensorModal}`).modal("show");
            }
          }
        }
      }
    });

    this.form.controls.sen_left.valueChanges.subscribe(async (value) => {
        if (value != this.form.value["sen_left"]) {
          let sen_left = this.form.getRawValue().sen_left || [];
          let sen_right = this.form.getRawValue().sen_right || [];

          if((sen_left.length + sen_right.length) > this.number_of_sensor){
            sen_left.splice(-1);
            this.form.get("sen_left").setValue(sen_left);

            $(`${this.limitGraphModal}`).modal('show');
          }else{
            if (sen_left) {
              await this.getSenLeft(sen_left);
            } else {
              this.sensorDataLeft = [];
            }
          }
          this.setSessionStorage();
          this.resetTemplate();
        }
    });

    this.form.controls.farm_right.valueChanges.subscribe(async (value) => {
        if (value != this.form.value["farm_right"]) {
          this.form.get("plot_right").setValue("");
          this.form.get("thing_right").setValue("");
          this.form.get("sen_right").setValue("");
          await this.GraphService.getPlotDashboard(value[0].id)
            .then((success) => {
              this.plotDashboardRight = success.data.plot;
              this.plotRight = this.plotDashboardRight.map((plot) => {
                return {
                  id: plot._id,
                  label: plot.name,
                };
              });

              if (this.plotRight.length > 0) {
                if (this.setting_graph.plot_right && this.plotRight.find(plot=> plot.id == this.setting_graph.plot_right[0].id)) {
                  this.form.get("plot_right").setValue(this.setting_graph.plot_right);
                } else {
                  this.form.get("plot_right").setValue([this.plotRight[0]]);
                }
                this.resetTemplate();
              }
            })
            .catch((err) => {
              this.plotRight = [];
              this.thingRight = [];
              this.sensorDataLeft = [];
              $(`${this.emptyPlotModal}`).modal("show");

              this.setSessionStorage();
              this.resetTemplate();
            });
        }
    })

    this.form.controls.plot_right.valueChanges.subscribe(async (value) => {

        if (value != this.form.value["plot_right"]) {
          this.form.get('thing_right').setValue("");
          this.form.get('sen_right').setValue("");
          this.thingRight = [];
          
          if (value[0]) {
            let plotList = this.plotDashboardRight
            .filter(plot=> plot._id == this.form.getRawValue().plot_right[0].id);
            await Promise.all(plotList
              .map(async plot=>{
  
                await Promise.all(plot.thing
                  .map(async thing=>{
                    this.thingRight.push(
                      {
                        id:  thing.thing_id,
                        label: thing.thing_name,
                        data: thing
                      }
                    )
                }));
    
                if(this.thingRight.length > 0){
                  if (this.setting_graph.thing_right && this.thingRight.find(thing=> thing.id == this.setting_graph.thing_right[0].id)) {
                    this.form.get("thing_right").setValue(this.setting_graph.thing_right);
                  } else {
                    this.form.get("thing_right").setValue([this.thingRight[0]]);
                  }
                }else{
                  this.thingRight = [];
                  $(`${this.emptyThingModal}`).modal("show");
                }
                this.resetTemplate();
            }));
          }
        }
    });

    this.form.controls.thing_right.valueChanges.subscribe(async (value) => {

      if (value != this.form.value["thing_right"]) {
        this.form.get("sen_right").setValue("");
        this.senRight = [];
        
        if (value[0]) {
          let plot =  this.plotDashboardRight.find(plot=> plot._id == this.form.getRawValue().plot_right[0].id)
         
          if(plot){
            let thing = plot.thing.find(thing=> thing.thing_id == this.form.getRawValue().thing_right[0].id);

            if(thing){
    
              this.senRight = thing.sensor.map(sen=>{
                return {
                  id: sen.sensor_id,
                  label: sen.sensor_name,
                  data: sen
                }
              });

              if(this.senRight.length > 0){

                if (this.setting_graph.sen_right && this.senRight.find(sen=> sen.id == this.setting_graph.sen_right[0].id)) {
                  this.form.get("sen_right").setValue(this.setting_graph.sen_right);
                } else {
                  this.form.get("sen_right").setValue([this.senRight[0]]);
                }
              }else{
                this.senRight = [];
                $(`${this.emptySensorModal}`).modal("show");
              }
            }else{
              this.senLeft = [];
              $(`${this.emptySensorModal}`).modal("show");
            }
          }
        }
      }
    });

    this.form.controls.sen_right.valueChanges.subscribe(
      async (value) => {

        if(value != this.form.value['sen_right']){
          let sen_left = this.form.getRawValue().sen_left || [];
          let sen_right = this.form.getRawValue().sen_right || [];

          if((sen_left.length + sen_right.length) > this.number_of_sensor){
            sen_right.splice(-1);
            this.form.get("sen_right").setValue(sen_right);

            $(`${this.limitGraphModal}`).modal('show');
          }else{
            if (sen_right) {
              await this.getSenRight(sen_right);
            } else {
              this.sensorDataRight = [];
            }
          }
          this.setSessionStorage();
          this.resetTemplate();
        }
      }
    );
  }

  async getSenLeft(sen_left){
    this.sensorDataLeft = [];
    this.loadingGraph = true;
    for (let i = 0; i < sen_left.length; i++) {
      await this.GraphService.getSensorData(this.form.getRawValue().thing_left[0].id, sen_left[i].id, this.form.getRawValue().receive_date).then(res=>{
        if(res.data){
  
          this.sensorDataLeft.push(res.data[0]);
        }
      }).catch(err=>{
        console.log(err);
      })
    }
    this.loadingGraph = false;
    this.resetTemplate();
  }

  async getSenRight(sen_right){
    this.sensorDataRight = [];
    this.loadingGraph = true;
    for (let i = 0; i < sen_right.length; i++) {
      await this.GraphService.getSensorData( this.form.getRawValue().thing_right[0].id, sen_right[i].id, this.form.getRawValue().receive_date).then(res=>{
        if(res.data){
          
          this.sensorDataRight.push(res.data[0]);
        }
      }).catch(err=>{
        console.log(err);
      })
    }
    this.loadingGraph = false;
    this.resetTemplate();
  }

  patchValue(e, controlName){
    this.form.get(controlName).setValue(e);
  }

  async getFarmselect() {
    this.loading = true;
    try{
      await this.GraphService.getDropdownDashboard()
      .then(success => {
        if(success['data']){
  
          this.farmLeft = success.data.FarmList.map(farm=>{
            return {
              id: farm._id,
              label: farm.name
            }
          });
          this.farmRight = success.data.FarmList.map(farm=>{
            return {
              id: farm._id,
              label: farm.name
            }
          });
  
          if(this.farmLeft.length > 0){
            if(this.setting_graph.farm_left){
              this.form.get('farm_left').setValue(this.setting_graph.farm_left);
            }else{
              this.form.get('farm_left').setValue([this.farmLeft[0]])
            }
          }
  
          if(this.farmRight.length > 0){
            if(this.setting_graph.farm_right){
              this.form.get('farm_right').setValue(this.setting_graph.farm_right);
            }
          }
        }
  
        this.loading = false;
        this.resetTemplate();
      });
    }catch(error){
      this.loading = false;
      this.resetTemplate();
    }
  }

  resetTemplate(){
    this.filter.emit(this.form.getRawValue());
    this.cd.detectChanges();
  }
}
